import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Shell } from "./components/Shell";
import { ToastProvider } from "./components/Toast";
import { AuthProvider } from "./context/AuthContext";
import Home from "./pages/Home";
import Login from "./pages/Login";
import Portals from "./pages/Portals";
import Prompts from "./pages/Prompts";
import Packages from "./pages/Packages";
import StrategyDocAgent from "./pages/StrategyDocAgent";
import TeamworkDuplicates from "./pages/TeamworkDuplicates";
import Timesheets from "./pages/Timesheets";
import MyWork from "./pages/MyWork";
import Workflows from "./pages/Workflows";
import WorkflowCanvas from "./pages/WorkflowCanvas";
import Settings from "./pages/Settings";

export default function App() {
  return (
    <ToastProvider>
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/" element={<Shell />}>
              <Route index element={<Home />} />
              <Route path="portals" element={<Portals />} />
              <Route path="prompts" element={<Prompts />} />
              <Route path="packages" element={<Packages />} />
              <Route path="settings" element={<Settings />} />
              <Route path="tools/strategy-doc" element={<StrategyDocAgent />} />
              <Route path="tools/workflows" element={<Workflows />} />
              <Route
                path="tools/workflows/:portalId"
                element={<WorkflowCanvas />}
              />
              <Route
                path="tools/teamwork-duplicates"
                element={<TeamworkDuplicates />}
              />
              <Route path="tools/timesheets" element={<Timesheets />} />
              <Route path="tools/my-work" element={<MyWork />} />
            </Route>
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </ToastProvider>
  );
}
